import { logDebug } from 'middleware/logger';

export const SEARCH_FILTER_KEY = 'searchFilter';

// Don't use these directly unless you really need to.  Otherwise you should go through the
// localStorage reducer as it puts the data into redux and also saves to/ hydrates from localStorage automatically
export const loadFromLocalStorage = <T>(key: string, fallback?: T) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const serializedData = window?.localStorage.getItem(key);
    if (serializedData === null) {
      return fallback;
    }
    return JSON.parse(serializedData);
  } catch (err) {
    logDebug('Local storage not enabled for this user', err);
    return fallback;
  }
};

export const saveToLocalStorage = (key: string, data: any) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const serializedData = JSON.stringify(data);
    window?.localStorage.setItem(key, serializedData);
  } catch (err) {
    logDebug('Local storage not enabled for this user', err);
  }
};

export const deleteFromLocalStorage = (key: string) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window?.localStorage.removeItem(key);
  } catch (err) {
    logDebug('Local storage not enabled for this user', err);
  }
};
